/*
 * @Description: 路由配置
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: hai-27
 * @LastEditTime: 2020-02-27 13:58:48
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [

  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('../views/Order.vue'),
    meta: {
      requireAuth: true // 需要验证登录状态
    }
  },
  {
    path: '/Personalcenter',
    name: 'MyProfile',
    component: () => import('../views/Personalcenter/MyProfile.vue'),
    meta: {
      requireAuth: true // 需要验证登录状态
    },
    children: [
      {
        path: 'Orderlist',
        name: 'Orderlist',
        component: () => import('../views/Personalcenter/Orderlist.vue'),
      },
      {
        path: 'Ordersub',
        name: 'Ordersub',
        component: () => import('../views/Personalcenter/Ordersub.vue'),
      },
      {
        path: 'Cart',
        name: 'Cart',
        component: () => import('../views/Personalcenter/Cart.vue'),
      },
      {
        path: 'Profile',
        name: 'Profile',
        component: () => import('../views/Personalcenter/Profile.vue'),
      },
    ]
  },
  {
    path: '/placeOrder',
    name: 'PlaceOrder',
    component: () => import('../views/PlaceOrder.vue'),
    meta: {
      requireAuth: true // 需要验证登录状态
    }
  },
  {
    path: '/finishedorder',
    name: 'FinishedOrder',
    component: () => import('../views/FinishedOrder.vue'),
    meta: {
      requireAuth: true // 需要验证登录状态
    }
  },
  {
    path: '/finishedregister',
    name: 'FinishedRegister',
    component: () => import('../views/FinishedRegister.vue'),
  },
  {
    path: '/company',
    name: 'Company',
    component: () => import('../views/Company.vue'),
  },
  {
    path: '/catelog',
    name: 'catelog',
    component: () => import('../views/catelog.vue'),
  },
  {
    path: '/howplace',
    name: 'Howplace',
    component: () => import('../views/Howplace.vue'),
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('../views/Product.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
  },
  {
    path: '/events',
    name: 'Events',
    component: () => import('../views/Events.vue')
  },
  {
    path: '/eventscenter',
    name: 'Eventscenter',
    component: () => import('../views/Eventscenter.vue'),
    beforeEnter: (to, from, next) => {
      if (!to.query.id) {
        // 如果没有 id 参数，重定向到首页
        next({ name: 'Events' });
      } else {
        // 如果有 id 参数，继续导航
        next();
      }
    }
  },
  {
    path: '/ourbrands',
    name: 'OurBrands',
    component: () => import('../views/OurBrands.vue'),
  },
  {
    path: '/exploreGigwi',
    name: 'ExploreGigwi',
    component: () => import('../views/ExploreGigwi.vue'),
  },
  {
    path: '/exploregp',
    name: 'ExploreGp',
    component: () => import('../views/ExploreGp.vue'),
  },
  {
    path: '/explorepetgeek',
    name: 'ExplorePetgeek',
    component: () => import('../views/ExplorePetgeek.vue'),
  },
  {
    path: '/exploreskipdawg',
    name: 'ExploreSkipdawg',
    component: () => import('../views/ExploreSkipdawg.vue'),
  },
  {
    path: '/aboutus',
    name: 'AboutUs',
    component: () => import('../views/AboutUs.vue'),
  },
  {
    path: '/brandassets',
    name: 'Brandassets',
    component: () => import('../views/Brandassets.vue'),
  },
  {
    path: '/contactus',
    name: 'ContactUs',
    component: () => import('../views/ContactUs.vue'),
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('../views/FAQ.vue'),
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('../views/Terms.vue'),
  },
  {
    path: '/policy',
    name: 'Policy',
    component: () => import('../views/Policy.vue'),
  },
  {
    path: '/detail',
    name: 'Detail',
    component: () => import('../views/Detail.vue'),
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../components/Error.vue')
  },
]

const router = new Router({
  // base: '/dist',
  mode: 'history',
  routes,
})
/* 由于Vue-router在3.1之后把$router.push()方法改为了Promise。所以假如没有回调函数，错误信息就会交给全局的路由错误处理。
vue-router先报了一个Uncaught(in promise)的错误(因为push没加回调) ，然后再点击路由的时候才会触发NavigationDuplicated的错误(路由出现的错误，全局错误处理打印了出来)。*/
// 禁止全局路由错误处理打印
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

export default router
